// Module
var code = "<template> <compose view-model=\"app/cm/components/summary/household-case-summary\" model.bind=\"modelData\"></compose> </template> ";
// Exports
module.exports = code;